<ol class="ui-pipeline-strip">
  @for (stage of stages(); track stage.id; let last = $last; let first = $first) {
    <li class="ui-pipeline-strip__stage">
      <span class="ui-pipeline-strip__badge">{{ first ? '01' : stage.id }}</span>
      <span class="ui-pipeline-strip__label">{{ stage.label }}</span>
    </li>

    @if (!last) {
      <li class="ui-pipeline-strip__connector" aria-hidden="true"></li>
    }
  }
</ol>
